import { Locale } from 'modules/i18n';

export const referralCodeButtonTranslation = {
  [Locale.en]: {
    label: 'Referral code',
  },
};
